import { PhoneIncoming, PhoneOff } from 'lucide-react'
import { Button } from '#app/components/ui/button.tsx'
import {
	Sheet,
	SheetContent,
	SheetDescription,
	SheetHeader,
	SheetTitle,
} from '#app/components/ui/sheet.tsx'
import { formatPhone } from '#app/utils/phone.ts'
import { useSoftphone } from './softphone-provider.tsx'

/**
 * « Appel entrant » bottom sheet while the browser rings. Dismissing it
 * (drag, overlay) counts as a refusal: Support-center then rings the
 * agent's mobile, and the voicemail after that.
 */
export function SoftphoneIncomingSheet() {
	const { call, accept, reject } = useSoftphone()
	const open = call?.direction === 'inbound' && call.phase === 'ringing'

	return (
		<Sheet
			open={open}
			onOpenChange={(next) => {
				if (!next) reject()
			}}
		>
			<SheetContent
				side="bottom"
				className="gap-0 rounded-t-none border-0 p-0"
				onOpenAutoFocus={(e) => e.preventDefault()}
			>
				<SheetHeader className="border-border border-b p-4 pr-12">
					<p className="text-plq-rouge flex items-center gap-2 text-[11px] font-semibold tracking-[0.15em] uppercase">
						<span
							className="bg-plq-rouge h-1.5 w-1.5 animate-pulse rounded-full"
							aria-hidden="true"
						/>
						Centre d'appel
					</p>
					<SheetTitle className="flex items-center gap-2.5 text-xl font-bold">
						<PhoneIncoming
							className="h-5 w-5 shrink-0 animate-pulse text-sky-600"
							aria-hidden="true"
						/>
						Appel entrant
					</SheetTitle>
					<SheetDescription className="tabular-nums">
						{call?.number ? formatPhone(call.number) : 'Numéro masqué'}
						{call?.language === 'en' ? ' · service en anglais' : ''}
						{call?.ticketId ? ` · ticket #${call.ticketId}` : ''}
					</SheetDescription>
				</SheetHeader>

				<div className="grid grid-cols-2 gap-3 p-4">
					<Button
						type="button"
						variant="outline"
						className="h-14 text-base"
						onClick={reject}
					>
						<PhoneOff className="mr-2 h-5 w-5" aria-hidden="true" />
						Refuser
					</Button>
					<Button
						type="button"
						className="h-14 bg-green-600 text-base text-white hover:bg-green-700"
						onClick={accept}
					>
						<PhoneIncoming className="mr-2 h-5 w-5" aria-hidden="true" />
						Répondre
					</Button>
					<p className="text-muted-foreground col-span-2 text-xs">
						Sans réponse ici, l'appel sonnera sur votre cellulaire.
					</p>
				</div>
			</SheetContent>
		</Sheet>
	)
}
